import NinLogTypes from './types';

const initialState = {
  ninLog: { data: [], resultTotal: 0 },
  fetchingNinLog: false,
  error: null,
};

function ninLogReducer(state = initialState, { type, payload }) {
  switch (type) {
    case NinLogTypes.FETCH_NIN_LOG_START:
      return {
        ...state,
        fetchingNinLog: true,
      };
    case NinLogTypes.FETCH_NIN_LOG_SUCCESS:
      return {
        ...state,
        fetchingNinLog: false,
        ninLog: payload,
      };
    case NinLogTypes.FETCH_NIN_LOG_FAILURE:
      return {
        ...state,
        fetchingNinLog: false,
        error: payload,
      };
    default:
      return state;
  }
}

export default ninLogReducer;
